module.exports = __webpack_public_path__ + "static/media/createproject.a904138d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Help/assets/createproject.png
// module id = 1868
// module chunks = 193